import {
  getOfferingsUrl,
  getOfferingsWithPlanDataForContextUrl,
} from "../config/Config";
import { getRequest } from "./ServiceHelper";

export class OfferingService {
  static getOfferingsByFacultyID = (facultyId) => {
    return getRequest(getOfferingsUrl(facultyId));
  };

  static getOfferingsWithPlanDataForContext = ({
    contextId,
    futureMappings,
  }) => {
    const params = {};
    if (futureMappings) {
      params.futureMappings = futureMappings;
    }
    return getRequest(getOfferingsWithPlanDataForContextUrl(contextId), params);
  };
}
